module.exports = __webpack_public_path__ + "static/media/season1.b5dc6b58.webp";